<template lang="pug">
modal#collect-recipient-modal(
  :no-footer='true'
  :title='$t("modal.collectRecipientPhoto.title")'
  @closed='onCloseModal'
  ref='modal'
  size='sm'
)
  div(v-show='step === 1')
    p {{ $t('modal.collectRecipientPhoto.step1.message') }}
    p {{ $t('modal.collectRecipientPhoto.step1.instructions') }}
    ul
      li {{ $t('modal.collectRecipientPhoto.step1.point1') }}
      li {{ $t('modal.collectRecipientPhoto.step1.point2') }}
      li {{ $t('modal.collectRecipientPhoto.step1.point3') }}
    .text-center.mt-5
      img.img-fluid(src='/img/ilustrations/user-collect-photo.svg')
    .text-end.mt-4
      button.btn.btn-primary.ms-2(
        @click='step += 1'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.collectRecipientPhoto.step1.nextButton') }}
  div(v-show='step === 2')
    camera-photo(
      @photo='photo = $event'
      ref='photo'
      style='min-height: 230px'
    )
    .text-end.mt-4
      button.btn.btn-primary.ms-2(
        @click='takePhoto'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.collectRecipientPhoto.step2.takePhotoButton') }}
  div(v-show='step === 3')
    img(:src='photo' v-if='photo')
    .text-end(style='margin-top: 1.9rem')
      button.btn.btn-secondary(
        @click='step -= 1'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.collectRecipientPhoto.step3.retryButton') }}
      button.btn.btn-primary.ms-4(
        @click='send'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.collectRecipientPhoto.step3.sendButton') }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import CameraPhoto from '@/ui/molecules/CameraPhoto.vue';

export default {
  name: 'CollectRecipientPhotoModal',
  props: {
    envelopeId: [Number, String],
  },
  components: {
    Modal,
    CameraPhoto,
  },
  data() {
    return {
      step: 1,
      photo: '',
    };
  },
  watch: {
    step(v) {
      if (v === 2) {
        this.$refs.photo.start();
      }
    },
  },
  methods: {
    takePhoto() {
      this.step += 1;
      this.$refs.photo.capture();
    },
    onCloseModal() {
      this.$refs.photo.stopStream();
      this.step = 1;
      this.photo = '';
    },
    send() {
      this.$emit('photo', this.photo);
      this.$refs.modal.close();
    },
  },
};
</script>
